import { render, staticRenderFns } from "./invoiceTemplate.vue?vue&type=template&id=2372143b&scoped=true"
import script from "./invoiceTemplate.vue?vue&type=script&lang=js"
export * from "./invoiceTemplate.vue?vue&type=script&lang=js"
import style0 from "./invoiceTemplate.vue?vue&type=style&index=0&id=2372143b&prod&scoped=true&lang=css"
import style1 from "./invoiceTemplate.vue?vue&type=style&index=1&id=2372143b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2372143b",
  null
  
)

export default component.exports